// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LCCz","right":"styles_right__3L_mu"};